import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { catchError, finalize } from "rxjs/operators";
import { AbstractService } from "../../abstractions/abstract.service";
import { Globals } from "../../app.globals";

@Injectable()
export class QualityAssuranceAdminService extends AbstractService {
    constructor(http: HttpClient, globals: Globals) {
        super(http, globals);
    }

    getUnassignedSupervisors(): Promise<UnassignedSupervisor[]> {
        return this.getAll<UnassignedSupervisor>(
            "unassigned/supervisors"
        ).toPromise();
    }

    getUnassignedSubcontractorContacts(): Promise<
        UnassignedSubcontractorContact[]
    > {
        return this.getAll<UnassignedSubcontractorContact>(
            "unassigned/subcontractor-contacts"
        ).toPromise();
    }

    getAssignedSupervisors(): Promise<AssignedSupervisor[]> {
        return this.getAll<AssignedSupervisor>(
            "assigned/supervisors"
        ).toPromise();
    }

    getAssignedSubcontractorContacts(): Promise<
        AssignedSubcontractorContact[]
    > {
        return this.getAll<AssignedSubcontractorContact>(
            "assigned/subcontractor-contacts"
        ).toPromise();
    }

    saveSupervisors(ids: number[]): Promise<any> {
        this.showSpinner();
        return this.http
            .post(this.getApiUrl() + "/supervisors", ids)
            .pipe(
                catchError(this.handleError),
                finalize(() => this.hideSpinner())
            )
            .toPromise();
    }

    saveSubcontractorContacts(ids: number[]): Promise<any> {
        this.showSpinner();
        return this.http
            .post(this.getApiUrl() + "/subcontractor-contacts", ids)
            .pipe(
                catchError(this.handleError),
                finalize(() => this.hideSpinner())
            )
            .toPromise();
    }

    deleteSupervisor(id: number): Promise<any> {
        this.showSpinner();
        return this.http
            .delete(this.getApiUrl() + "/supervisors/" + id)
            .pipe(
                catchError(this.handleError),
                finalize(() => this.hideSpinner())
            )
            .toPromise();
    }

    deleteSubcontractorContacts(id: number): Promise<any> {
        this.showSpinner();
        return this.http
            .delete(this.getApiUrl() + "/subcontractor-contacts/" + id)
            .pipe(
                catchError(this.handleError),
                finalize(() => this.hideSpinner())
            )
            .toPromise();
    }

    canAccess(accessTypes: string[]): Promise<boolean> {
        return this.http
            .post<boolean>(this.getApiUrl() + "/can-access", accessTypes)
            .toPromise();
    }

    getAccessLevel(accessTypes: string[]): Promise<string> {
        return this.http
            .post<string>(this.getApiUrl() + "/access-level", accessTypes)
            .toPromise();
    }

    getApiUrl(): string {
        return "api/quality-assurance/admin";
    }
}

export class UnassignedSupervisor {
    employeeId: number;
    fullName: string;
}

export class UnassignedSubcontractorContact {
    subcontractorContactId: number;
    fullName: string;
    subcontractorName: string;
}

export class AssignedSupervisor {
    id: number;
    fullName: string;
    email: string;
    role: string;
    status: string;
}

export class AssignedSubcontractorContact {
    id: number;
    fullName: string;
    subcontractorName: string;
    email: string;
    role: string;
    status: string;
}
